
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pet/compare",
      function () {
        return require("private-next-pages/pet/compare.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pet/compare"])
      });
    }
  